import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { GET_CUSTOMER_REQUESTS_KEY } from '~/features/customers/hooks/useGetCustomerRequests'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'
import { CustomerRequest } from '~/supabase/types'

export const useCreateCustomerRequest = () => {
  const queryClient = useQueryClient()
  const { mutate: notifyError } = useNotifyError()

  return useMutation({
    mutationKey: ['create-request'] as const,
    mutationFn: async (data: Omit<CustomerRequest, 'id' | 'created_at'>) => {
      const { error } = await supabaseApi.from('customer_requests').insert(data)

      if (error) {
        toast.error('Customer request could not be created.')
        notifyError({
          error,
          function: 'useCreateCustomerRequest',
          message: 'Customer request could not be created.',
          data: { payload: data },
        })
        throw error
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CUSTOMER_REQUESTS_KEY] })
      toast.success('Request successfully created')
    },
  })
}
